import React from 'react'
import axios from 'axios'
import { withRouter } from 'react-router-dom'
import { loginVipSuccess } from '../../redux/user.redux.js'
import { connect } from 'react-redux'
import {userList} from '../../redux/chatuser.redux.js'
import {getBigBGUrl} from '../../redux/chatuser.redux.js'
import {setCookie} from '../../util.js'
import {getCookie} from '../../util.js'

@withRouter
@connect(
	state=>state.chatuser,
	{userList,getBigBGUrl}
)
class AuthRoute extends React.Component{
	componentDidMount() {
		
		axios.get('/fapi/getAdvPics?kind=2')
	        .then((res)=>{
	            if(res.data.return_code===0){
	                var str = ''
	                str=res.data.data?res.data.imghost+res.data.data.imgurl:null
	               	this.props.getBigBGUrl(str)
	                
	               
	            }
	            
	     })
		axios.get('/fapi/checkLogin')
			.then(res=>{	
				 
				const pathname = this.props.location.pathname
				
				if (res.data.return_code===0) {										
					this.props.userList(res.data.data)					
				
				}else {
					
					const MyOrigin = window.location.href
					
					if(res.data.redirect_url){
						setCookie('vip_redirect',MyOrigin)
						
						window.location.href = res.data.redirect_url
						
					}
					this.props.userList({code:-1})
					const arr=['/my-welfare','/my-member','/my-message']
					if(arr.indexOf(pathname)>-1){
						/*
						axios.get('/fapi/getLoginURL?redirect_url='+pathname)
					      .then(res=>{
						
					      	
					       	if(res.data.return_code===0){
					       		window.location.href = res.data.redirect_url
					 
					       	}
					     
					    })
					    */
					    
					     const ipath = {
						    pathname:'/login',
						    query:this.props.location.pathname
						 }

						 this.props.history.push(ipath)
					}
				
				}

		})
		
	
	}
	
	render(){
		return null
	}

}
export default AuthRoute


// WEBPACK FOOTER //
// ./src/component/auth-route/AuthRoute.js